import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    scrollContent: {
        justifyContent: "center",
        alignItems: "center"
    },
    paddedMarginContainer: {
        minHeight: 120
    },
    marginContainer: {
        marginBottom: 20
    },
    contentContainer: {
        maxWidth: 850,
        width: "100%"
    },
    editor: {
        minHeight: 350
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
